<div class="assignment-block" fxLayout="column" fxLayoutAlign="start center">
	<ng-container *ngIf="!data?.loader">
		<!-- <div class="card-icon" *ngIf="data?.icon" (click)="info(data)">
				<mat-icon class="mat-assign-icon">{{data?.icon}}</mat-icon>
			</div> -->
		<div class="card-content" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="1 1">
			<div class="assignment-card cursor-pointer" (click)="info(data)" *ngIf="data && (data | objectKeys : [])?.length">
				<div class="assignment-chip sub-txt-patch" [ngClass]="data?.statusCode" fxLayoutAlign="center center"
					*ngIf="data?.status">
					{{data?.status}}
				</div>
				<div class="assignment-container" fxLayout="column" fxLayoutAlign="start stretch"
					*ngIf="(data?.assigner | objectKeys : [])?.length || (data?.assigner | objectKeys : [])?.length || data?.infoIcon || data?.infoSVGIcon || data?.assignee?.length">

					<div class="asg-card-info" fxFlex="1 1" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px"
						fxLayoutAlign.xs="space-between stretch" fxLayoutGap.xs="40px">

						<div class="assign-detail" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="1 1"
							*ngIf="(data?.assigner && (data?.assigner | objectKeys : [])?.length) || data?.assignee?.length">

							<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px"
								*ngIf="data?.assigner && (data?.assigner | objectKeys : [])?.length">
								<!-- <div class="thumbnail">
										<img [src]="data?.assigner?.image" [attr.alt]="data?.assigner?.name"
											onError="this.src = 'assets/img/dummyimg1.png'">
									</div>
									<span class="sub-text-1">{{data?.assigner?.name}}</span> -->
								<app-chips classes="capitalize" type="prime" (title)="searchPeopleDetail(data?.assigner)"
									[data]="{title: data?.assigner?.name, imageSrc: data?.assigner?.image}">
								</app-chips>
							</div>

							<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px"
								[ngClass]="{'assignee-detail': data?.assignee?.length > 1 }" *ngIf="data?.assignee?.length">

								<div>
									<div class="tree-point">
									</div>
								</div>
								<ng-container *ngIf="data?.assignee[0]?.hasOwnProperty('image')">
									<app-chips classes="capitalize" type="prime" class="active-prime" (title)="searchPeopleDetail(data?.assignee[0])"
										[data]="{title: (data?.assignee?.length > 1) ? (data?.assignee[0].name + ' + ' + (data?.assignee?.length - 1)) : data?.assignee[0].name, imageSrc: data?.assignee[0].image}">
									</app-chips>
								</ng-container>
								<ng-container *ngIf="data?.assignee[0].svgIcon">
									<app-chips classes="capitalize" type="prime" class="active-prime" (title)="searchPeopleDetail(data?.assignee[0])"
										[data]="{title: (data?.assignee?.length > 1) ? (data?.assignee[0].name + ' + ' + (data?.assignee?.length - 1)) : data?.assignee[0].name, svgIcon: data?.assignee[0].svgIcon}">
									</app-chips>
								</ng-container>
								<!-- <div class="thumbnail">
                    <img [src]="data?.assignee[0].image" [attr.alt]="data?.assignee[0].name"
                      onError="this.src = 'assets/img/dummyimg1.png'">
                  </div>
                  <span class="sub-text-1">{{data?.assignee[0].name}}
                    <ng-container *ngIf="data?.assignee?.length > 1">
                      + {{data?.assignee?.length - 1}}
                    </ng-container>
                  </span> -->
							</div>

						</div>

						<div class="assign-info" fxFlex="0 1 83px" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="15px"
							fxLayoutGap.xs="5px" fxFlex.xs="0 0"
							*ngIf="(data?.info | objectKeys : [])?.length || data?.infoIcon || data?.infoSVGIcon">
							<div class="submit-details" *ngIf="(data?.info | objectKeys : [])?.length && data?.info?.caption">
								<p class="sub-caption-2">{{data?.info?.caption}}</p>
								<p class="short-caption">{{data?.info?.value}}</p>
							</div>
							<div class="info-icon" *ngIf="data?.infoIcon || data?.infoSVGIcon" fxLayoutAlign="center center">
								<mat-icon [svgIcon]="data?.infoSVGIcon" [matTooltip]="data?.infoTooltip">
									{{data?.infoIcon}}
								</mat-icon>
							</div>
						</div>

					</div>

				</div>
			</div>
			<div class="assigned-content-view" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1">
				<ng-content select="content-area"></ng-content>
			</div>
		</div>
	</ng-container>
	<ng-container *ngIf="data?.loader">
		<!-- <div fxLayout="column" fxLayoutAlign="start stretch" class="shinner-loader">
      <div class="thumbnail-circle"></div>
      <div class="wrapper" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="5px">
        <div class="thumbnail shimmer"></div>
        <div fxLayout="column" fxLayoutGap="5px" class="wrapper-lines">
          <div>
            <div class="comment-line animate" fxFlex="80%"></div>
          </div>
          <div>
            <div class="comment-line animate" fxFlex="100%"></div>
          </div>
          <div>
            <div class="comment-line animate" fxFlex="100%"></div>
          </div>
        </div>
      </div>
    </div> -->
		<div class="shimmer loader" fxLayout="column" fxLayoutAlign="start stretch">
			<!-- <div class="thumbnail-circle"></div> -->
			<div fxFlex="60px"></div>
			<div class="loader-content" fxFlex="1 1" fxLayout="row" fxLayoutAlign="space-between stretch">
				<div class="bg-active" fxFlex="20px"></div>
				<div fxFlex="1 1" fxLayout="column" fxLayoutAlign="start stretch">
					<div class="bg-active" fxFlex="20px"></div>
					<div fxFlex="10px" fxLayout="row" fxLayoutAlign="start stretch">
						<div fxFlex="0 0 70%"></div>
						<div class="bg-active" fxFlex="1 1"></div>
					</div>
					<div class="bg-active" fxFlex="10px"></div>
					<div fxFlex="10px"></div>
					<div class="bg-active" fxFlex="10px"></div>
					<div fxFlex="10px"></div>
					<div class="bg-active" fxFlex="1 1"></div>
				</div>
				<div class="bg-active" fxFlex="20px"></div>
			</div>
		</div>
	</ng-container>
	<!-- <div class="shiny-loader" fxLayout="column" fxLayoutAlign="start stretch">
      <div class="shape assignment-icon-ph" fxFlex="30px"></div>
      <div fxFlex="1 1" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
        <div class="shape" fxFlex="90px"></div>
        <div class="content-block" fxFlex="1 1" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
          <div fxLayout="row" fxLayoutAlign="start start">
            <div class="shape" fxFlex="70%"></div>
          </div>
          <div class="shape"></div>
          <div class="shape"></div>
        </div>
      </div>
    </div> -->
</div>
